import {ReactElement} from "react";
import "../res/css/styles.css";

export function Numpad(props: { onKey: (key: string) => void }): ReactElement {
  const handleKey = (key: string) => {
    props.onKey(key);
  };

  return <div className="numpad">
    {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map(k =>
      <button key={k} className="np" onClick={() => handleKey(k)}>{k}</button>
    )}
    <button className="np" onClick={() => handleKey("+")}>+</button>
    <button className="np" onClick={() => handleKey("0")}>0</button>
    <button className="np del" onClick={() => handleKey("BACKSPACE")}>⌫</button>
  </div>;
}
